import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { message, Card } from 'antd';
import { getSkipCount } from 'utils';
import { debounce } from 'lodash';
import { DownloadOutlined } from '@ant-design/icons';
import { AddButton, AddIcon } from 'modules/requests/requests.styles';
import {
  TableView,
  StyledExportButton,
} from '../../../components/StyledLayout/Layout.styled';
import SearchHeader from '../../../components/SearchHeader';
import {
  getSortType,
  ProductTableColumn,
  exportExcelFile,
} from './listing.helper';
import { deleteProduct, getProducts } from 'redux/actions/productActions';
import {
  selectAllProducts,
  selectProductCount,
  selectProductLoading,
  setFilters,
} from 'redux/reducers/productReducer';

const ProductListing = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const allCatgeories = useSelector(selectAllProducts);
  const isLoading = useSelector(selectProductLoading);
  const allProductsListCount = useSelector(selectProductCount);
  const initialPageConfig = {
    current: 1,
    pageSize: 10,
    limit: 10,
    skip: getSkipCount(1, 10),
    role: 'admin',
  };
  const [pageConfig, setPageConfig] = useState(initialPageConfig);

  const onChange = (pagination, filters, sorter) => {
    const newPageConfig = {
      current: pagination.current,
      pageSize: pagination.pageSize,
      limit: pagination.pageSize,
      skip: getSkipCount(pagination.current, pagination.pageSize),
      sortBy: getSortType(sorter),
      status: filters?.status ? filters.status[0] : '',
      userType: filters?.userType ? filters.userType[0] : '',
      searchKey: pageConfig?.searchKey,
      role: 'admin',
    };
    setPageConfig(newPageConfig);
    window.scrollTo(0, 0);

    dispatch(setFilters(newPageConfig));
  };

  const onProductDelete = async (product) => {
    try {
      const body = {
        productId: product._id,
      };
      await dispatch(deleteProduct(body));
      message.success('Product deleted successfully');
      dispatch(getProducts(pageConfig));
    } catch (err) {
      message.error('Error while deleting Product');
    }
  };

  useEffect(() => {
    dispatch(getProducts(pageConfig));
  }, [dispatch, pageConfig]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleSearch = debounce((e) => {
    setPageConfig({
      ...pageConfig,
      searchKey: e.target.value,
    });
  }, 500);

  const ProductColumns = ProductTableColumn(onProductDelete);
  const tableRef = useRef(null);

  return (
    <>
      <SearchHeader handleSearch={handleSearch} />
      <Card
        title="Products"
        bordered={true}
        extra={
          <>
            <AddButton onClick={() => navigate('/dashboard/addProduct')}>
              <AddIcon style={{ marginRight: '4px' }} />
              New
            </AddButton>
            <StyledExportButton
              onClick={() => {
                exportExcelFile(allCatgeories, 'product');
              }}
            >
              <DownloadOutlined /> Export{' '}
            </StyledExportButton>
          </>
        }
      >
        <TableView
          ref={tableRef}
          columns={ProductColumns}
          dataSource={allCatgeories}
          pagination={{
            position: ['none', 'bottomRight'],
            total: allProductsListCount,
            showSizeChanger: false,
            showTotal: (total, range) =>
              `${range[0]}-${range[1]} of ${total} Products`,
            showQuickJumper: true,
            defaultPageSize: 50,
            ...pageConfig,
          }}
          scroll={{ x: 1000 }}
          onChange={onChange}
          loading={isLoading}
          bordered={true}
        />
      </Card>
    </>
  );
};

ProductListing.propTypes = {};

export default ProductListing;
